(function() {
    'use strict';

    angular
        .module('cloudApp')
        .controller('ProfileController', ProfileController);

    ProfileController.$inject = ['Auth', 'Principal', 'DbhawkUserService'];

    function ProfileController (Auth, Principal, DbhawkUserService) {
        var vm = this;

        vm.changeProfile = changeProfile;
        vm.error = null;
        vm.success = null;
		vm.profileParam = {};

        Principal.identity().then(function(account) {
			vm.profileParam.email = account.email;
        });
		
	    DbhawkUserService.getCompanyDetails().then(
            function (response) {
				vm.profileParam.company_name = response.data.companyName;

            }).catch(function (response) {
          
        });

        function changeProfile () {
    
        }

    }
})();
